var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c(
        "v-container",
        { staticClass: "pb-0", attrs: { fluid: "" } },
        [
          _c("p", { staticClass: "text-subtitle-1 font-weight-medium" }, [
            _vm._v("Select Items"),
          ]),
          _c(
            "InputGeneric",
            { attrs: { label: "Type" } },
            [
              _c("v-autocomplete", {
                attrs: { items: _vm.typeItems, dense: "" },
                model: {
                  value: _vm.type,
                  callback: function ($$v) {
                    _vm.type = $$v
                  },
                  expression: "type",
                },
              }),
            ],
            1
          ),
          _c(
            "InputGeneric",
            { attrs: { label: "Source" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  items: _vm.sourceItems,
                  dense: "",
                  placeholder: "All",
                  clearable: "",
                },
                model: {
                  value: _vm.source,
                  callback: function ($$v) {
                    _vm.source = $$v
                  },
                  expression: "source",
                },
              }),
            ],
            1
          ),
          _c(
            "InputGeneric",
            { attrs: { label: "Connected Node" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  items: _vm.nodeItems,
                  dense: "",
                  placeholder: "All",
                  clearable: "",
                },
                model: {
                  value: _vm.node,
                  callback: function ($$v) {
                    _vm.node = $$v
                  },
                  expression: "node",
                },
              }),
            ],
            1
          ),
          _c("v-divider", { staticClass: "mb-4" }),
          _c("p", { staticClass: "text-subtitle-1 font-weight-medium" }, [
            _vm._v("Properties"),
          ]),
          _vm._l(_vm.affectedProperties, function (property, i) {
            return _c(
              "v-row",
              {
                key: property.key,
                attrs: { dense: "", justify: "space-between" },
              },
              [
                _c(
                  "v-col",
                  { attrs: { cols: "12", md: "8" } },
                  [
                    _c("v-autocomplete", {
                      attrs: {
                        value: property.key,
                        dense: "",
                        items: _vm.propertiesItems,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.updateProperty($event, i, "key")
                        },
                      },
                    }),
                  ],
                  1
                ),
                property.key
                  ? _c(
                      "v-col",
                      { attrs: { cols: "12", md: "3" } },
                      [
                        _c("Pass", {
                          attrs: { schema: _vm.schema[property.key] },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var schema = ref.schema
                                  return [
                                    _c("InputFromSchema", {
                                      attrs: {
                                        value: property.value,
                                        schema: schema,
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.updateProperty(
                                            $event,
                                            i,
                                            "value"
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "v-col",
                  { attrs: { cols: "12", md: "1" } },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { icon: "" },
                        on: {
                          click: function ($event) {
                            return _vm.removeProperty(i)
                          },
                        },
                      },
                      [_c("v-icon", [_vm._v("mdi-close")])],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _c(
            "v-btn",
            {
              staticClass: "mb-2",
              attrs: {
                rounded: "",
                block: "",
                text: "",
                small: "",
                color: "primary",
              },
              on: { click: _vm.addProperty },
            },
            [_c("v-icon", [_vm._v("mdi-plus")])],
            1
          ),
          _c("v-divider"),
          _c(
            "v-expansion-panels",
            { attrs: { flat: "" } },
            [
              _c(
                "v-expansion-panel",
                [
                  _c(
                    "v-expansion-panel-header",
                    {
                      staticClass: "pl-0",
                      scopedSlots: _vm._u([
                        {
                          key: "actions",
                          fn: function () {
                            return [
                              _c("v-icon", { staticClass: "icon" }, [
                                _vm._v("mdi-menu-down"),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [_c("span", { staticClass: "header" }, [_vm._v("Summary")])]
                  ),
                  _c(
                    "v-expansion-panel-content",
                    { staticClass: "text-caption" },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "pa-1",
                          attrs: { outlined: "", flat: "" },
                        },
                        [
                          _c("p", { staticClass: "mb-0" }, [
                            _vm._v(
                              _vm._s(
                                "Items affected (total: " +
                                  _vm.affectedItems.length +
                                  "):"
                              )
                            ),
                          ]),
                          _c(
                            "ul",
                            _vm._l(_vm.affectedItems, function (item) {
                              return _c("li", { key: item.id }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      item.name + " (id: " + item.id + ")"
                                    ) +
                                    " "
                                ),
                              ])
                            }),
                            0
                          ),
                          _c("p", { staticClass: "mb-0 mt-2" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  "Properties affected (total: " +
                                    _vm.affectedProperties.length +
                                    "):"
                                ) +
                                " "
                            ),
                          ]),
                          _c(
                            "ul",
                            _vm._l(_vm.affectedProperties, function (prop) {
                              return _c(
                                "li",
                                { key: prop.key },
                                [
                                  _c("Pass", {
                                    attrs: { schema: _vm.schema[prop.key] },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var schema = ref.schema
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(schema.title) +
                                                  ": " +
                                                  _vm._s(prop.value) +
                                                  " " +
                                                  _vm._s(schema.unit) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "v-card-actions",
        [
          _c("v-spacer"),
          _c(
            "v-btn",
            { attrs: { color: "error", text: "" }, on: { click: _vm.cancel } },
            [_vm._v(" cancel ")]
          ),
          _c(
            "v-btn",
            {
              attrs: { color: "primary", text: "", type: "submit" },
              on: { click: _vm.save },
            },
            [_vm._v(" save ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }